export default {
  ENV: 'production',
  API_URL: 'https://admin.nippybrands.com/api',
  CATEGORIES_IMAGES_URL: 'https://admin.nippybrands.com/uploads/categories/',
  USERS_IMAGES_URL: 'https://admin.nippybrands.com/uploads/users/',
  LIMIT: 20,
  SORT_BY: 'id',
  SORT_TYPE: 'DESC'
};
